import React from "react";

import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { MessageBox, MessageBoxType } from "@molecules/MessageBox";

import ModalContentTemplate from "@components/templates/ModalContentTemplate/ModalContentTemplate";

import "./SmartFormCommentsModalTemplate.scss";

function SmartFormCommentsModalTemplate(props) {
  const {
    title,
    commentComposer,
    commentsThread,
    entityPermissionType,
    currentProjectConfig,
    loadingOrNoContentMessage,
    onClose,
    leftSidePanel,
    conversationTitle,
    isNewComment
  } = props;

  const { t } = useTranslation();

  const isPartialEntityPermissionType = entityPermissionType === "PARTIAL";
  const getBodyContent = () => {
    return (
      <div className="smart-form-comments-modal-template__comments-thread">
        {commentsThread}
      </div>
    );
  };

  const getFooterContent = () => {
    return (
      <div className="smart-form-comments-modal-template__composer">
        {isPartialEntityPermissionType &&
          currentProjectConfig?.entities?.enabled && (
            <MessageBox
              type={MessageBoxType.WARNING}
              message={t(
                "requests:requests.responses.addResponse.entityPermission.partial.warning"
              )}
            />
          )}

        {commentComposer}
      </div>
    );
  };

  const getLeftSidePanelContent = () => {
    return (
      <div className="smart-form-comments-modal-template__left-side-panel">
        {leftSidePanel}
      </div>
    );
  };

  return (
    <ModalContentTemplate
      onClose={onClose}
      modalClassName="smart-form-comments-modal-template"
      header={{ title, colouredBg: true, expandable: true }}
      body={{
        content: getBodyContent(),
        loadingOrNoContentMessage,
        conversationTitle,
        isNewComment
      }}
      footer={{
        content: getFooterContent(),
        hideCancel: true,
        handleCancel: onClose,
        buttonOverride: <></>,
        seperator: true
      }}
      leftSidePanel={getLeftSidePanelContent()}
    />
  );
}

SmartFormCommentsModalTemplate.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  commentComposer: PropTypes.node.isRequired,
  commentsThread: PropTypes.node.isRequired,
  entityPermissionType: PropTypes.string,
  currentProjectConfig: PropTypes.object,
  loadingOrNoContentMessage: PropTypes.string,
  leftSidePanel: PropTypes.node,
  conversationTitle: PropTypes.string,
  isNewComment: PropTypes.bool
};

export default SmartFormCommentsModalTemplate;
